import { Inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { fetch } from '@ngrx/router-store/data-persistence';
import { map } from 'rxjs/operators';
import {
  ConceptYearServiceInterface,
  CONCEPT_YEAR_SERVICE_TOKEN,
} from '../../concept-year/concept-year.service.interface';
import { ConceptQueries } from '../concept';
import { DalState } from '../dal.state.interface';
import {
  ConceptYearsActionTypes,
  ConceptYearsLoaded,
  ConceptYearsLoadError,
  LoadConceptYears,
} from './concept-year.actions';

@Injectable()
export class ConceptYearEffects {
  loadConceptYears$ = createEffect(() =>
    this.actions.pipe(
      ofType(ConceptYearsActionTypes.LoadConceptYears),
      concatLatestFrom(() => this.store.select(ConceptQueries.getLoaded)),
      fetch({
        run: (action: LoadConceptYears, loaded: boolean) => {
          if (!action.payload.force && loaded) return;
          return this.conceptYearService
            .getAllForUser(action.payload.userId)
            .pipe(map((conceptYears) => new ConceptYearsLoaded({ conceptYears })));
        },
        onError: (action: LoadConceptYears, error) => {
          return new ConceptYearsLoadError(error);
        },
      })
    )
  );

  constructor(
    private actions: Actions,
    private store: Store<DalState>,
    @Inject(CONCEPT_YEAR_SERVICE_TOKEN)
    private conceptYearService: ConceptYearServiceInterface
  ) {}
}
